import { Transform } from 'class-transformer';
import { sanitizeString } from '../utils';

export class OrderItemDto {
  /**
   * Customer reference to the order. (e.g order number from customer's order system)
   * @example 'R000023'
   */
  @Transform(({ value }) => sanitizeString(value))
  public customerPoNumber: string;
  /**
   * Barcode of the item.
   * @example '7630440612124'
   */
  public barcode: string;

  /**
   * Quantity of the item that have been cancelled.
   * @example 2
   */
  public cancelledQuantity: number;

  /**
   * Description of the item
   * @example 'Performance-T W Black | Dark XS'
   */
  public description: string;

  /**
   * Item number
   * @example '202.00237'
   */
  public itemNumber: string;

  /**
   * The date that the item will be on stock again
   * @example '2022-11-01T12:00:00Z'
   */
  public refillDate: string;

  /**
   * The date that the customer requested the item to be delivered
   * @example '2022-01-01T12:00:00Z'
   */
  public requestedDate: string;

  /**
   * Order number
   * @example 'SO010029657'
   */
  public orderNumber: string;

  /**
   * total of items ordered
   * @example 9
   */
  public orderedQuantity: number;

  /**
   * Status on the order item
   * @example 'unshipped'
   */
  public status: string;

  /**
   * total of items already delivered
   * @example 3
   */
  public totalDeliveredQuantity: number;

  /**
   * Total number of items to be delivered
   * @example 4
   */
  public totalToBeDelivered: number;

  /**
   * Order type name of the order that the item belongs to
   * @example 'Re-Order'
   */
  public orderType: string;
}
